:host {
  $columns: 100;

  @mixin height-x {
    @for $i from 1 through $columns {
      .height-#{$i} {
        height: #{$i}#{'%!important'};
      }
    }
  }

  @include height-x;

  .phone-stats {
    display: flex;
    flex-direction: column;
    width: 250px;
    justify-content: center;
    align-items: center;
    margin: 0 auto;

    .phone-stats-columns {
      display: flex;
      align-items: flex-end;
      height: 90px;
      margin: 0 auto;
      width: 100%;
    }

    .phone-stats-column {
      margin: 0 1px;
      box-sizing: border-box;
      border-radius: 4px 4px 0 0;
      height: 0;

      &--bg {
        width: 100%;
        height: 100%;
        border-radius: 4px 4px 0 0;
      }
    }

    .phone-stats-timeline {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-top: 5px;

      &__time {
        color: #666666;
        color: var(--font-secondary);
        font-size: 12px;
        letter-spacing: 0;
        line-height: 16px;
        text-align: center;
        white-space: nowrap;
      }
    }
  }

  .tooltip {
    position: relative;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    width: 180px;
    background-color: #333;
    background-color: var(--bg-tooltip);
    color: #f5f5f5;
    color: var(--font-tooltip);
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: calc(100% + 10px);
    opacity: 0;
    transition: opacity 0.3s;
    padding: 10px;
    box-shadow: 0 0 10px 0 rgba(51, 51, 51, 0.15);
    margin-left: 0;
    left: calc(50% - 90px);
    font-size: 14px;
    box-sizing: border-box;
  }

  .tooltip .tooltiptext::after {
    content: '';
    position: absolute;
    top: 100%;
    right: 50%;
    border-width: 5px;
    border-style: solid;
    border-color: #1c1c1e transparent transparent transparent;
    border-color: var(--bg-primary--invert) transparent transparent transparent;
    transform: translateX(50%);
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }

  /* -------------------------------------------------------------------------- */
  /*                                 RESPONSIVE                                 */
  /* -------------------------------------------------------------------------- */

  // Medium devices (tablets, 768px and up)
  @media (max-width: 768px) {
    .phone-stats {
      width: 80%;

      .phone-stats-columns {
        height: 70px;
      }
    }

    .tooltip .tooltiptext {
      width: 130px;
      left: calc(50% - 65px);
    }
  }
}
